import Routes from '../../../../routes';
import { JsonApiCurrentUser } from '../../../../@types/jsonapi';

function studentNavigation(): string {
  return Routes.dashboard;
}

function professionalNavigation(): string {
  return Routes.dashboard;
}

function moderatorNavigation(): string {
  return Routes.moderatorDashboard;
}

function visitorNavigation(): string {
  return Routes.home;
}

function companyAdminNavigation(): string {
  return Routes.companyAdminBase;
}

function schoolCoachNavigation(): string {
  return Routes.schoolAssignmentsBase;
}

/**
  * Picks the appropriate service based on the provided user and/or profile
  * @param {Object} param
  * @param {Object} param.user
  * @param {Object} param.profile
  * @param {String} param.context
  */
export const afterSigninNavigation = ({ user }: { user: JsonApiCurrentUser}) => {
  const navigations: { [key: string]: () => string } = {
    student: studentNavigation,
    mentor: professionalNavigation,
    employee: professionalNavigation,
    moderator: moderatorNavigation,
    schoolCoach: schoolCoachNavigation,
    companyAdmin: companyAdminNavigation,
    visitor: visitorNavigation,
    default: visitorNavigation,
  };

  const service = navigations[user.type] || navigations.default;
  return service();
};
